// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureId } from './FermentationProcedure';
import { fermentationAlertKindEnum } from './FermentationAlertKindEnum';
import { fermentationAttributeDefinitionId } from './FermentationAttributeDefinition';
import { fermentationAlertLimitModeEnum } from './FermentationAlertLimitModeEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationProcedureAlertId = (z.number());
export const fermentationProcedureAlert = z.object({
    id: fermentationProcedureAlertId,
    procedure_id: fermentationProcedureId,
    kind: fermentationAlertKindEnum,
    enabled: z.boolean(),
    duration_s: z.number(),
    attribute_id: fermentationAttributeDefinitionId.nullable(),
    limit_mode: fermentationAlertLimitModeEnum.nullable(),
    min_value: z.string().nullable(),
    max_value: z.string().nullable(),
    deviation_below: z.string().nullable(),
    deviation_above: z.string().nullable(),
    setpoint_attribute_id: fermentationAttributeDefinitionId.nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const fermentationProcedureAlertInitializer = z.object({
    id: fermentationProcedureAlertId.optional(),
    procedure_id: fermentationProcedureId,
    kind: fermentationAlertKindEnum,
    enabled: z.boolean().optional(),
    duration_s: z.number().optional(),
    attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    limit_mode: fermentationAlertLimitModeEnum.optional().nullable(),
    min_value: z.string().optional().nullable(),
    max_value: z.string().optional().nullable(),
    deviation_below: z.string().optional().nullable(),
    deviation_above: z.string().optional().nullable(),
    setpoint_attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const fermentationProcedureAlertMutator = z.object({
    id: fermentationProcedureAlertId.optional(),
    procedure_id: fermentationProcedureId.optional(),
    kind: fermentationAlertKindEnum.optional(),
    enabled: z.boolean().optional(),
    duration_s: z.number().optional(),
    attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    limit_mode: fermentationAlertLimitModeEnum.optional().nullable(),
    min_value: z.string().optional().nullable(),
    max_value: z.string().optional().nullable(),
    deviation_below: z.string().optional().nullable(),
    deviation_above: z.string().optional().nullable(),
    setpoint_attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationProcedureAlert.js.map